import { render, staticRenderFns } from "./zhuanjia.vue?vue&type=template&id=c38cf68e&"
import script from "./zhuanjia.vue?vue&type=script&lang=ts&"
export * from "./zhuanjia.vue?vue&type=script&lang=ts&"
import style0 from "./zhuanjia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports